import { useEffect } from 'react';
import { Cookies } from 'react-cookie';

const constants = require('./constants');
const cookies = new Cookies();


const Logout = props => {

  //  const updateMenu = props.updateMenuCb;
    useEffect(() => {
        console.log("LOGOUT...", constants.SERVER_URL+"/api/logout")
            fetch(constants.SERVER_URL+"/api/logout", {method:'get'})
            .then(resp => {
                console.log("Logout Done");
                cookies.remove('sessionToken', {path:"/"});
                if(resp.redirected) {
                    console.log("REDIRECTED: ", resp)
                    window.location.href = resp.url;
                }
                //updateMenu();
            })
            .catch(err => {
                console.log("Logout error", err);
              //  cookies.remove('sessionToken', {path:"/"});
              //  updateMenu();
            });
      });

    return null;
}

export default (Logout);
